import { Document, Page, pdfjs } from 'react-pdf'
import { IconLoading, LoadingContainer, SpinAntd } from '@/components/common/Map/styles'
import { ArrowLeftWrapper, DownloadWrapper, IconSvg, ModalWrapper } from './styles'
import { IMAGE_URL } from '@/constant/IMAGE'

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.js', // เปลี่ยนจาก .mjs เป็น .js
  import.meta.url,
).toString()

const PreviewPdfModal = ({
  pdf,
  onCancel,
  visible,
}: {
  pdf?: string | null
  onCancel: () => void
  visible: boolean
}) => {
  if (!pdf) {
    return null
  }

  return (
    <ModalWrapper
      open={visible}
      onCancel={onCancel}
      closable={false}
      footer={false}
      centered
      width={620}
    >
      <Document
        renderMode="canvas"
        file={pdf}
        onLoadProgress={() => (
          <LoadingContainer>
            <SpinAntd indicator={<IconLoading style={{ fontSize: 55 }} spin />} />
          </LoadingContainer>
        )}
        loading={
          <LoadingContainer>
            <SpinAntd indicator={<IconLoading style={{ fontSize: 55 }} spin />} />
          </LoadingContainer>
        }
      >
        <Page
          pageNumber={1}
          renderTextLayer={false}
          renderAnnotationLayer={false}
          renderForms={false}
        />
      </Document>
      <ArrowLeftWrapper onClick={onCancel}>
        <IconSvg src={IMAGE_URL.arrowLeftIcon} alt="download" />
      </ArrowLeftWrapper>
      <DownloadWrapper>
        <a href={pdf} target="_blank" rel="noreferrer" type="application/pdf" download>
          <IconSvg src={IMAGE_URL.downloadGrayIcon} alt="download" />
        </a>
      </DownloadWrapper>
    </ModalWrapper>
  )
}

export default PreviewPdfModal
